import { useEffect } from 'react'
import { site } from '@/config/site'
import { routeMeta } from '@/config/routes'

interface Props {
  path: string
}

function upsertMeta(attr: 'name' | 'property', key: string, value: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`)
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute(attr, key)
    document.head.appendChild(el)
  }
  el.setAttribute('content', value)
}

/**
 * Keeps <head> in sync on client-side navigation. The first load already has
 * the right tags: scripts/prerender.mjs writes them from the same route config.
 */
export function Seo({ path }: Props) {
  useEffect(() => {
    const meta = routeMeta(path)
    const url = `${site.url}${path === '/' ? '/' : path}`

    document.title = meta.title
    upsertMeta('name', 'description', meta.description)
    upsertMeta('name', 'robots', meta.noindex ? 'noindex, follow' : 'index, follow, max-image-preview:large')
    upsertMeta('property', 'og:title', meta.title)
    upsertMeta('property', 'og:description', meta.description)
    upsertMeta('property', 'og:url', url)
    upsertMeta('name', 'twitter:title', meta.title)
    upsertMeta('name', 'twitter:description', meta.description)

    let canonical = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]')
    if (!canonical) {
      canonical = document.createElement('link')
      canonical.rel = 'canonical'
      document.head.appendChild(canonical)
    }
    canonical.href = url
  }, [path])

  return null
}
